import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  GET_AZURE_CDN,
  GET_AZURE_CDN_SUCCESS,
  GET_AZURE_CDN_ERROR,
} from "./constant";

import { getAzureCDNApi } from "./api";

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */
function* getAzureCDNList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getAzureCDNApi, params, provider);
    yield put({ type: GET_AZURE_CDN_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_AZURE_CDN_ERROR, error });
  }
}

/**
 * Get Login Saga
 */
export function* manageAzureCDNSaga() {
  yield takeLatest(GET_AZURE_CDN, getAzureCDNList);
}
